import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ICategoryPartResponse, IVehicleCategoryPartsFilters } from "../models/Part";

export default function useVehicleCategoryPartsOptimized(
  vehicleId: string | undefined,
  categoryId: string | undefined,
  filters?: IVehicleCategoryPartsFilters
) {
  const { post } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const effectiveFilters: IVehicleCategoryPartsFilters = {
    includeSold: filters?.includeSold ?? true,
    limitSold: filters?.limitSold ?? 50,
    matchMake: filters?.matchMake ?? true,
    matchModel: filters?.matchModel ?? true,
    matchDoors: filters?.matchDoors ?? true,
    matchSeries: filters?.matchSeries ?? false,
    matchExactYear: filters?.matchExactYear ?? true,
    matchYearRange: filters?.matchYearRange ?? true,
    yearFrom: filters?.yearFrom,
    yearTo: filters?.yearTo,
    matchEngineCode: filters?.matchEngineCode ?? true,
    matchTransmission: filters?.matchTransmission ?? true,
  };

  const parts = useQuery({
    queryKey: ["vehicleCategoryParts", vehicleId, categoryId, effectiveFilters],
    queryFn: () =>
      post<any, ICategoryPartResponse>(
        `/part/vehicle/${vehicleId}/part-categories/${categoryId}/parts/search`,
        {
          includeSold: effectiveFilters.includeSold,
          limitSold: effectiveFilters.limitSold,
          matchMake: effectiveFilters.matchMake,
          matchModel: effectiveFilters.matchModel,
          matchDoors: effectiveFilters.matchDoors,
          matchSeries: effectiveFilters.matchSeries,
          matchExactYear: effectiveFilters.matchExactYear,
          matchYearRange: effectiveFilters.matchYearRange,
          yearFrom: effectiveFilters.yearFrom,
          yearTo: effectiveFilters.yearTo,
          matchEngineCode: effectiveFilters.matchEngineCode,
          matchTransmission: effectiveFilters.matchTransmission,
        }
      ),
    enabled: !!vehicleId && !!categoryId,
    staleTime: staleTime,
  });

  return {
    parts,
  };
}

